import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQItem = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 py-4" data-id="element-143">
      <button className="flex justify-between items-center w-full text-left font-medium text-gray-900" onClick={() => setIsOpen(!isOpen)} data-id="element-144">
        <span data-id="element-145">{question}</span>
        {isOpen ? <ChevronUpIcon className="h-5 w-5 text-blue-600" data-id="element-146" /> : <ChevronDownIcon className="h-5 w-5 text-blue-600" data-id="element-147" />}
      </button>
      {isOpen && <div className="mt-2 text-gray-700" data-id="element-148">{answer}</div>}
    </div>;
};
const FAQ = () => {
  return <section id="faq" className="py-16 bg-white" data-id="element-149">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="text-center mb-16" data-id="element-151">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-152">
            よくあるご質問
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-153">
            サービスに関する一般的なご質問にお答えいたします。
          </p>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-154">
          <FAQItem question="スタッフの手配はどのくらいの期間で可能ですか？" answer="通常のご依頼は24時間以内にスタッフの手配が可能です。緊急または当日のご依頼の場合は、できる限り対応させていただきますので、まずはご相談ください。" data-id="element-155" />
          <FAQItem question="キャンセル料はかかりますか？" answer="24時間前までのキャンセルは無料です。当日キャンセルの場合は、料金の50%をキャンセル料として申し受けます。" data-id="element-156" />
          <FAQItem question="清掃に必要な道具や洗剤は持参しますか？" answer="はい、すべての清掃用具、洗剤、消耗品は当社で用意いたします。特別なご要望がございましたら、事前にお申し付けください。" data-id="element-157" />
          <FAQItem question="清掃スタッフの保険はどうなっていますか？" answer="すべてのスタッフは労災保険および賠償責任保険に加入しております。万が一の事故や破損の際も適切に対応させていただきます。" data-id="element-158" />
          <FAQItem question="領収書の発行は可能ですか？" answer="はい、ご要望に応じて領収書を発行させていただきます。電子領収書もご用意可能です。" data-id="element-159" />
          <FAQItem question="定期的な清掃の契約は可能ですか？" answer="はい、週1回から月1回など、お客様のご要望に合わせた定期清掃プランをご用意しております。定期契約の場合は割引料金も適用されます。" data-id="element-160" />
        </div>
      </div>
    </section>;
};
export default FAQ;